import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import {  Card, CardBody, Col, Form, FormFeedback, Input, Label, Modal, ModalBody, ModalHeader, Row, UncontrolledTooltip } from 'reactstrap';

//import images
import company from "../../../assets/images/svg/company.svg";
import TableContainer from 'Components/Common/TableContainer';
import { numberWithCommas } from "../../../helpers/globalHelper"
import * as Yup from "yup";
import { useFormik } from 'formik';
import { useOrgFindAllQuery, useOrgCreateMutation, useOrgDeleteMutation, useOrgUpdateMutation } from '../../../store';
import DeleteModal from 'Components/Common/DeleteModal';

import Spinners from 'Components/Common/Spinner';


const Detail = () => {

  const [customQuery, setCustomQuery] = useState<any>();
  const [isLoading, setLoading] = useState(true)

  const { data, error, isFetching } = useOrgFindAllQuery(customQuery);
  const [orgCreate, orgCreateResult] = useOrgCreateMutation();
  const [orgUpdate, orgUpdateResult] = useOrgUpdateMutation();
  const [orgDelete, orgDeleteResult] = useOrgDeleteMutation();

  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [modal_backdrop, setmodal_backdrop] = useState(false);
  const [companyInfoModal_backdrop, setCompanyInfoModal_backdrop] = useState(false);
  const [companyRegisterInfo, setCompanyRegisterInfo] = useState(null as any);
  const [inputCompanyRegister, setInputCompanyRegister] = useState('');

  const [waterOrg, setWaterOrg] = useState<any>();
  const [waterOrgCount, setWaterOrgCount] = useState<any>();
  const [waterOrgList, setWaterOrgList] = useState<any>();


  // Datatable дээр pagination харуулахад хэрэгтэй
  const [customPagination, setCustomPagination] = useState<any>();
  const [customPageSize, setCustomPageSize] = useState<any>();
  const [customPageLength, setCustomPageLength] = useState<any>();



  useEffect(() => {
    setWaterOrgList(data?.data)
    setLoading(false)
    setWaterOrgCount(waterOrgList?.length)
    setCustomPagination(data?.pagination)
    const tempQuery = `?page=${customPageLength !== undefined ? customPageLength : 1}&pageSize=${customPageSize !== undefined ? customPageSize : 25}`;
    setCustomQuery(tempQuery)
  }, [data, waterOrgList, customPageSize, customPageLength, customPagination])



  const toggle = useCallback(() => {
    if (modal_backdrop) {
      setmodal_backdrop(false);
    } else {
      setmodal_backdrop(true);
    }
  }, [modal_backdrop]);

  function removeBodyCss() {
    document.body.classList.add("no_padding");
  }

  function tog_backdrop() {
    setWaterOrg(null);
    setmodal_backdrop(!modal_backdrop);
    removeBodyCss();
  }

  function companyInfo_backdrop() {
    setCompanyInfoModal_backdrop(!companyInfoModal_backdrop);
    removeBodyCss();
  }

  function companyRegisterCheck() {
    setCompanyRegisterInfo('Эрхэт Инноваци ХХК')
  }

  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = (orgRowData) => {
    setWaterOrg(orgRowData);
    setDeleteModal(true);
  };

  const handleDeletejob = () => {
    if (waterOrg) {
      orgDelete(waterOrg.organization_id);
      setDeleteModal(false);
    }
  };

  const handleJobClick = useCallback((arg: any) => {
    const orgData = arg;
    console.log(orgData);
    
    setWaterOrg({
      id: orgData.organization_id,
      register: orgData.register,
      type: orgData.type,
      name: orgData.name,
      display: orgData.display,
      phone: orgData.phone,
    });

    

    setIsEdit(true);
    toggle();
  }, []);

  const columns = useMemo(
    () => [
      {
        header: '№',
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps: any) => {
          return <Link to="#" className="text-body fw-bold">{cellProps.row.original.organization_id}</Link>
        }
      },
      {
        header: "Компаний нэр",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Регистрийн дугаар',
        accessorKey: "register",
        enableColumnFilter: false,
        enableSorting: true,
      },
      // {
      //   header: 'Байгуулагдсан он',
      //   accessorKey: "establishedYear",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      // },
      // {
      //   header: 'Ажилчидын тоо',
      //   accessorKey: "staffCount",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      // },
      {
        header: 'Утас',
        accessorKey: "phone",
        enableColumnFilter: false,
        enableSorting: false,
      },
      // {
      //   header: 'Утас',
      //   accessorKey: "companyPhone",
      //   enableColumnFilter: false,
      //   enableSorting: false,
      // },
      // {
      //   header: 'Цахим шуудан',
      //   enableColumnFilter: false,
      //   enableSorting: true,
      //   accessorKey: "companyEmail"
      // },
      {
        header: 'Үйлдэл',
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cellProps: any) => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0">
              <li data-bs-toggle="tooltip" data-bs-placement="top" title="View">
                <a onClick={(event: any) => {
                  setWaterOrg(cellProps.row.original);
                  companyInfo_backdrop();
                }} className="btn btn-sm btn-soft-primary">
                  <i className="mdi mdi-eye-outline" id="viewtooltip"></i></a>
                <UncontrolledTooltip placement="top" target="viewtooltip" transition={{ timeout: 300 }}>
                  View
                </UncontrolledTooltip>
              </li>

              <Link
                  to="#"
                  className="btn btn-sm btn-soft-warning"
                  onClick={(event: any) => {
                    const orgData = cellProps.row.original;
                    event.preventDefault();
                    handleJobClick(orgData);
                  }}
                >
                  <i className="mdi mdi-pencil-outline" id="edittooltip" />
                  <UncontrolledTooltip placement="top" target="edittooltip">
                    Засах
                  </UncontrolledTooltip>
                </Link>


              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-danger"
                  onClick={(event: any) => {
                    const orgRowData = cellProps.row.original;
                    event.preventDefault();
                    onClickDelete(orgRowData);
                  }}
                >
                  <i className="mdi mdi-delete-outline" id="deletetooltip" />
                  <UncontrolledTooltip placement="top" target="deletetooltip">
                    Delete
                  </UncontrolledTooltip>
                </Link>
              </li>
            </ul>
          );
        }
      },
    ],
    []
  );

  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: waterOrg?.id,
      register: waterOrg?.register,
      type: waterOrg?.type,
      name: waterOrg?.name,
      display: waterOrg?.display,
      phone: waterOrg?.phone,
    },
    validationSchema: Yup.object({}),
    onSubmit: (values: any) => {
      if (isEdit) {
        const updateOrgList = {
          id: waterOrg?.id,
          register: values?.register,
          type: values?.type,
          name: values?.name,
          // display: values?.display,
          phone: values?.phone,
        };
        
        orgUpdate(updateOrgList)
      } else {
        const newOrgList = {
          register: values["register"],
          type: values["type"],
          name: values["name"],
          display: values["name"],
          phone: values["phone"],
        };
        orgCreate(newOrgList)
        validation.resetForm();
      }
      toggle()
    },
  });

  return (
    <React.Fragment>
      <DeleteModal
        deleteName={waterOrg?.name}
        show={deleteModal}
        onDeleteClick={handleDeletejob}
        onCloseClick={() => setDeleteModal(false)}
      />
      <Col xl={12}>
        <Card>
          <CardBody className="border-bottom">
            <div className="d-flex align-items-center">
              <img src={company} alt="" height="50" />
              <div className="flex-grow-1 ms-3">
                <h5 className="fw-semibold">Мэдээлэл</h5>
                <ul className="list-unstyled hstack gap-2 mb-0">
                  <li>
                    <i className="mdi mdi-table-row-height"></i> <span className="text-muted fw-semibold">Нийт: {numberWithCommas(waterOrgCount)}</span>
                  </li>
                </ul>
              </div>
              <button
                type="button"
                onClick={() => {
                  tog_backdrop();
                }}
                className="btn btn-success  btn-label"
              >
                <i className="mdi mdi-file-plus-outline label-icon"></i> Шинээр нэмэх
              </button>
            </div>

          </CardBody>

          <CardBody>
            {
              isLoading ? <Spinners setLoading={setLoading} />
                :
                <>

                  <TableContainer
                    setCustomPageSize={setCustomPageSize}
                    setCustomPageLength={setCustomPageLength}
                    customPagination={customPagination}

                    columns={columns}
                    data={waterOrgList || ""}
                    isCustomPageSize={true}
                    // isGlobalFilter={true}
                    isPagination={true}
                    colWidth={2}
                    SearchPlaceholder="Компани хайх . . ."
                    tableClass="align-middle dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                    pagination="pagination"
                    paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                  />
                </>
            }
          </CardBody>

        </Card>
      </Col>

      <Modal
        // size="xl"
        isOpen={modal_backdrop}
        toggle={() => {
          tog_backdrop();
        }}
        backdrop={'static'}
        id="staticBackdrop"
        centered
      >
        <ModalHeader toggle={() => {
          tog_backdrop();
        }}>
          <div className="h5 modal-title" id="staticBackdropLabel">{!!isEdit ? "Байгууллага" : "Байгууллага шинээр нэмэх"}</div>
        </ModalHeader>

        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <ModalBody>
            {/* <Alert color="warning" className="mb-3">
              <strong className="text-danger">(*)</strong> тэмдэг бүхий талбарыг {""}
              <Link to="#" className="alert-link">
                заавал бөглөх
              </Link>  шаардлагатайг анхаарна уу !!!
            </Alert> */}
            <Row>
              <Col lg={12}>
                {/* <div className="mb-3">
                  <Label className="text-danger">Байгууллагын регистер *</Label>
                  <div className='input-group'>
                    <Input
                      name="register"
                      type="text"
                      placeholder='Байгууллагын регистер'
                      validate={{
                        required: { value: true },
                      }}
                      onChange={(e) => setInputCompanyRegister(e.target.value)}
                      onBlur={validation.handleBlur}
                      value={inputCompanyRegister}
                    />
                    <button type="button" onClick={() => {
                      companyRegisterCheck();
                    }} className="btn btn-primary">Шалгах</button>
                  </div>
                  {companyRegisterInfo !== null ? (<>
                    <Alert color="success" className='mt-3'>
                      <Link to="#" className="alert-link">
                        {inputCompanyRegister} {" "}
                      </Link>
                      регистерийн дугаартай {" "}
                      <Link to="#" className="alert-link">
                        {companyRegisterInfo}
                      </Link>
                    </Alert>
                  </>) : ''}
                </div> */}

                <div className="mb-3">
                  <Label className="fw-semibold"> Байгууллагын регистер </Label>
                  <Input
                    name="register"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.register || ""}
                    invalid={
                      validation.touched.register &&
                        validation.errors.register
                        ? true
                        : false
                    }
                  />
                  {validation.touched.register &&
                    validation.errors.register ? (
                    <FormFeedback type="invalid">
                      {validation.errors.register}
                    </FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label className="fw-semibold"> Байгууллагын төрөл </Label>
                  <Input
                    name="type"
                    type="select"
                    className='form-select'
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.type || ""}
                    invalid={
                      validation.touched.register &&
                        validation.errors.register
                        ? true
                        : false
                    }
                  >
                    <option value="" disabled> Сонгох</option>
                    <option value="goverment"> Улсын</option>
                    <option value="business"> Хувийн</option>
                    </Input>
                  {validation.touched.register &&
                    validation.errors.register ? (
                    <FormFeedback type="invalid">
                      {validation.errors.register}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label className="fw-semibold"> Нэр </Label>
                  <Input
                    name="name"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.name || ""}
                    invalid={
                      validation.touched.name &&
                        validation.errors.name
                        ? true
                        : false
                    }
                  />
                  {validation.touched.name &&
                    validation.errors.name ? (
                    <FormFeedback type="invalid">
                      {validation.errors.name}
                    </FormFeedback>
                  ) : null}
                </div>
                {/* <div className="mb-3">
                  <Label className="fw-semibold"> Нэр  </Label>
                  <Input
                    name="display"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.display || ""}
                    invalid={
                      validation.touched.display &&
                        validation.errors.display
                        ? true
                        : false
                    }
                  />
                  {validation.touched.display &&
                    validation.errors.display ? (
                    <FormFeedback type="invalid">
                      {validation.errors.display}
                    </FormFeedback>
                  ) : null}
                </div> */}
                <div className="mb-3">
                  <Label className="fw-semibold"> Утас </Label>
                  <Input
                    name="phone"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.phone || ""}
                    invalid={
                      validation.touched.phone &&
                        validation.errors.phone
                        ? true
                        : false
                    }
                  />
                  {validation.touched.phone &&
                    validation.errors.phone ? (
                    <FormFeedback type="invalid">
                      {validation.errors.phone}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col>
            </Row>
          </ModalBody>

          <div className="modal-footer">
            <button type="button" className="btn btn-light" onClick={() => { setmodal_backdrop(false); }}>
              Хаах
            </button>
            <button type="submit" className="btn btn-primary">Хадгалах</button>
          </div>
        </Form>

      </Modal>

      <Modal
        size="xl"
        isOpen={companyInfoModal_backdrop}
        toggle={() => {
          companyInfo_backdrop();
        }}
        backdrop={'static'}
        id="staticBackdrop"
        centered
      >
        <ModalHeader toggle={() => {
          companyInfo_backdrop();
        }}>
          <div className="h5 modal-title" id="staticBackdropLabel"> Байгууллагын дэлгэрэнгүй мэдээлэл</div>
        </ModalHeader>

        <ModalBody>
          <Row>
            <Col lg={6}>
              <div className="mb-3">
                <Label> Компаний нэр </Label>
                <Input
                  name="title"
                  type="text"
                  disabled
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={waterOrg?.name}
                />
              </div>
              <div className="mb-3">
                <Label> Регистрийн дугаар </Label>
                <Input
                  name="title"
                  type="text"
                  disabled
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={waterOrg?.register}
                />
              </div>
              <div className="mb-3">
                <Label> Байгуулагдсан он </Label>
                <Input
                  name="title"
                  type="text"
                  disabled
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={waterOrg?.establishedYear}
                />
              </div>
              <div className="mb-3">
                <Label> Ажилчидын тоо </Label>
                <Input
                  name="title"
                  type="text"
                  disabled
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={waterOrg?.staffCount}
                />
              </div>
              <div className="mb-3">
                <Label> Утас </Label>
                <Input
                  name="title"
                  type="text"
                  disabled
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={waterOrg?.phone_no}
                />
              </div>
              <div className="mb-3">
                <Label> Цахим шуудан </Label>
                <Input
                  name="title"
                  type="text"
                  disabled
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={waterOrg?.email}
                />
              </div>
              <div className="mb-3">
                <Label> Хаяг </Label>
                <Input
                  name="title"
                  type="text"
                  disabled
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={waterOrg?.address}
                />
              </div>
            </Col>

            <Col lg={6}>
              <div className="mb-3">
                <Label> Веб сайт </Label> <br />
                <a target='__blank' className='alert-link' href="https://www.erkhet-innovation.com/">https://www.erkhet-innovation.com/</a>
              </div>
              <div className="mb-3">
                <Label> Сошиал хуудас </Label> <br />
                <a target='__blank' className='alert-link' href="https://www.facebook.com/profile.php?id=100071016612048"> <i className='mdi mdi-facebook fs-2 text text-primary'>  </i> </a>
              </div>
              <div className="mb-3">
                <Label> Тусгай зөвшөөрөл </Label>
                <ol>
                  <li>Усны хайгуул, судалгаа явуулах</li>
                  <li>Усны барилга, байгууламжийн зураг төсөл боловсруулах</li>
                  <li>Цооног өрөмдөх, тоноглох, сэргээн засварлах</li>
                  <li>Усны барилга, байгууламж барих, сэргээн засварлах, шинэчлэх</li>
                  <li>Усны аудит хийх</li>
                </ol>
              </div>

              <div className="mb-3">
                <Label> Банкны нэр </Label>
                <Input
                  name="title"
                  type="text"
                  disabled
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={waterOrg?.bank_name}
                />
              </div>

              <div className="mb-3">
                <Label> Дансны дугаар </Label>
                <Input
                  name="title"
                  type="text"
                  disabled
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={waterOrg?.account_number}
                />
              </div>
            </Col>
            <Col lg={12}>
              <div className="mb-3">
                <Label> Байршил </Label>
                <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2991.27279640405!2d106.92988729999999!3d47.909568199999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNDfCsDU0JzM0LjUiTiAxMDbCsDU1JzQ3LjYiRQ!5e1!3m2!1sen!2smn!4v1729759944400!5m2!1sen!2smn" width="600" height="450" ></iframe>
              </div>
            </Col>
          </Row>
        </ModalBody>

      </Modal>
    </React.Fragment>
  );
}

export default Detail;